module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._h('div', {
    staticClass: "container"
  }, [_vm._h('div', {
    staticClass: "header clearfix"
  }, [_vm._h('nav', [_vm._h('ul', {
    staticClass: "nav nav-pills float-xs-right"
  }, [(!this.$store.state.autentificado) ? _vm._h('li', {
    staticClass: "nav-item"
  }, [_vm._h('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.conectar($event)
      }
    }
  }, ["Conectar"])]) : _vm._e(), " ", (this.$store.state.autentificado) ? _vm._h('li', {
    staticClass: "nav-item dropdown"
  }, [_vm._h('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._h('img', {
    staticClass: "rounded",
    attrs: {
      "src": _vm.usuarioActivo.photoURL,
      "height": "32px",
      "width": "32px",
      "alt": "..."
    }
  }), "\n              " + _vm._s(_vm.usuarioActivo.displayName) + "\n            "]), " ", _vm._h('div', {
    staticClass: "dropdown-menu ",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(0), " ", _vm._m(1), " ", _vm._h('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.desconectar($event)
      }
    }
  }, [_vm._m(2), " Salir"])])]) : _vm._e()])]), " ", _vm._m(3)]), " ", _vm._h('todolist', {
    attrs: {
      "autentificado": _vm.autentificado,
      "usuarioActivo": _vm.usuarioActivo
    }
  }), " ", _vm._m(4)]), " "])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._h('p'), " ", _vm._h('p', ["Perfil del usuario"])])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "dropdown-divider"
  })
},function (){var _vm=this;
  return _vm._h('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })
},function (){var _vm=this;
  return _vm._h('h3', {
    staticClass: "text-muted"
  }, ["Todolist \n      ", _vm._h('a', {
    staticClass: "btn btn-sm btn-link",
    attrs: {
      "href": "https://github.com/jqEmprendedorVE/todolist-vuejs",
      "target": "_blank"
    }
  }, [_vm._h('i', {
    staticClass: "fa fa-github-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), " Clone this App"])])
},function (){var _vm=this;
  return _vm._h('footer', {
    staticClass: "footer"
  }, [_vm._h('p', ["© Company 2014"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74df5e5b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 52
// module chunks = 2